import ListHead from "components/subHead/listHead";
import { useTranslation } from "react-i18next";
import { useSearchList } from "./service";
import { detail } from "./handles";
import ResvDetail from "./detail";
import useModalStore from "store/modal";
import Grid from "components/grid";
import { ResvResvCancelProvider } from "./context";

export default function ResvList() {
  const { t } = useTranslation();

  const { rowData, pageNav } = useSearchList();
  const onSetModal = useModalStore((state) => state.onSetModal);

  const theads = [
    ...prevTheads,
    {
      langNm: "grid_detail",
      type: "detail",
      field: "detail",
      width: 80,
      styles: "",
      click: (props: any) => {
        detail(props);

        // 상세페이지 오픈
        onSetModal({
          isOpen: true,
          title: t("md_ttl_resv_detail_cmm"),
          styles: "w-full",
          inner: (
            <ResvResvCancelProvider>
              <ResvDetail />,
            </ResvResvCancelProvider>
          ),
        });
      },
    },
  ];

  const cellstyle = (props: any) => {
    const color =
      props.colDef.field === "resvStaCdNm" &&
      (props.data.resvStaCd === "RC00"
        ? "#e65f45"
        : props.data.resvStatus === "done"
        ? "#8d99ae"
        : props.data.resvStatus === "wait"
        ? "#38b000"
        : "#8d99ae");

    return {
      color: color,
      fontWeith: 900,
    };
  };

  return (
    <>
      <div className="mt-[10px]">
        <ListHead totalRows={pageNav.totalRows} />
        <Grid
          theads={theads}
          rowData={rowData}
          pageNav={pageNav}
          cellstyle={cellstyle}
        />
      </div>
    </>
  );
}

const prevTheads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 60,
  },
  {
    langNm: "grid_resv_no",
    type: "string",
    field: "rmResvNo",
    width: 120,
  },

  {
    langNm: "grid_rmpd_resv_dt",
    type: "date",
    field: "rmPdResvDt",
    width: 100,
  },
  {
    langNm: "grid_sell_dt",
    type: "date",
    field: "sellDt",
  },
  {
    langNm: "grid_resv_status",
    type: "status",
    field: "resvStaCdNm",
    width: 80,
  },
  {
    langNm: "grid_rm_no",
    type: "string",
    field: "rmNo",
    width: 100,
  },
  {
    langNm: "grid_rm_nm",
    type: "string",
    field: "rmNm",
  },
  {
    langNm: "grid_rm_typ",
    type: "string",
    field: "rmTypNm",
  },
  {
    langNm: "grid_rm_olk",
    type: "string",
    field: "rmOlkNm",
  },

  {
    langNm: "grid_rmpd_nm",
    type: "string",
    field: "rmOpNm",
  },

  {
    langNm: "grid_mem_nm",
    type: "string",
    field: "resvMemNm",
  },
  {
    langNm: "grid_mem_phone",
    type: "phone",
    field: "resvMemMobNo",
  },
  {
    langNm: "grid_cst_nm",
    type: "string",
    field: "resvCstNm",
  },
  {
    langNm: "grid_cst_phone",
    type: "phone",
    field: "resvCstMblNo",
  },
  {
    langNm: "grid_rm_sell_amt",
    type: "price",
    field: "sellPri",
  },
  {
    langNm: "grid_resv_pay_amt",
    type: "price",
    field: "resvSumAmt",
  },
];
